import styled, { css } from "styled-components";

export const StyledDateRangeFilter = styled.div<{ mobile: boolean }>`
  ${({ mobile }) =>
    mobile &&
    css`
      width: 100%;
    `}
`;
